import { createSelector } from 'reselect';

const ppReducer = (state) => state.ppReducer;

export const ppSelector = createSelector(
    [ppReducer],
    (ppSlice) => {
        let ppData = ppSlice.productPlatforms.pp;
        if (!Array.isArray(ppData)) {
            return [];
        }

        return ppData;
    },
);